import dayjs, { Dayjs } from "dayjs"
import { getValidDayjs } from "../safeParse/getValidDayjs"

export const getTourValidDayjs = (value: any): Dayjs => {
  let dayjsValue: any = value.split('/').reverse().join('-')
  return getValidDayjs(dayjsValue)
}